import { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  NewTab,
  NewTableAdv,
  showToast,
  SmartTooltip,
  TableAdv,
  VerticalTabs,
} from "../../../../../components";
import { validateField } from "../../../../../components/Validations/Validation";
import { dateFormator, mapTableRows } from "../../../../../utils";
import Ats from "./Security/ModuleAccessTabs/Ats";
import Workforce from "./Security/ModuleAccessTabs/Workforce";
import AddRole from "./Security/Role/Modals/AddRole";
import ViewRole from "./Security/Role/Modals/ViewRole";
import UserList from "./Security/Role/Modals/UserList";
import { useDispatch, useSelector } from "react-redux";
import { getRolesStart } from "../../../../../redux/slices/setting/settingsSlice";
import { deleteRole } from "../../../../../redux/slices/setting/settingApi";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { useModuleAccess, usePagination } from "../../../../../hooks";
import Benchsales from "./Security/ModuleAccessTabs/Benchsales";
import { getItem } from "../../../../../utils/localStorageUtils";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import {
  getAllIpRestrictionsApi,
  addIpRestrictionApi,
  updateIpRestrictionApi,
  deleteIpRestrictionApi,
} from "../../../../../redux/slices/ip/ipApi";
import { convertFromUTC } from "../../../../../utils/dateUtils";
const BENCH_USER_MODULE = 4;
const Security = () => {
  const portal = getItem("portal");
  const [activeIndex, setActiveIndex] = useState(0);
  const [addRoleModal, setAddRoleModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editRoleModal, setEditRoleModal] = useState(false);
  const [editRoleData, setEditRoleData] = useState();
  const [userListModal, setUserListModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [ipList, setIpList] = useState([]);
  const [ipLoading, setIpLoading] = useState(false);
  const [ipForm, setIpForm] = useState({
    ip: "",
    // role: "",
    description:"",
    // user: "",
    ipExpiryDate: null,
  });
  const [ipEditForm, setIpEditForm] = useState({
    ip: "",
    // role: "",
    description:"",
    // user: "",
    ipExpiryDate: null,
  });
  const [editingIp, setEditingIp] = useState(null);
  const [ipEditModal, setIpEditModal] = useState(false);
  const [ipError, setIpError] = useState("");
  const [ipEditError, setIpEditError] = useState("");
  const [deletingIp, setDeletingIp] = useState(null);
  const [ipDeleteModal, setIpDeleteModal] = useState(false);

  const dispatch = useDispatch();

// for benchsales condition logic 
  const { userData: loginUserData } = useLoginUser();
  const moduleNumber = loginUserData?.role?.module;
  const isBenchUser = BENCH_USER_MODULE===moduleNumber; 


  // up to this 

  const roles = useSelector(
    (state) => state.settings.accessControls?.security?.roles || []
  );
  console.log(roles)
  const { loading } = useSelector((state) => state?.settings);
  const { value } = useSelector((state) => state.totalCount);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {}
  );
  const totalCount = value?.allRoles?.data || 0;
  const options = ["Role", "Module Access", "Report Access", "IP Whitelist"];
  const moduleList = ["ATS", "WorkForce"];
  const roleList = ["RA Manager", "RA Lead", "RA Associate"];
  const columns = [
    {
      key: "moduleName",
      label: "Module Name",
      render: (row) => <div className="text-info">{row.moduleName}</div>,
    },
    {
      key: "roleName",
      label: "Role Name",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center">
          <SmartTooltip description="View" noicon>
            <Button
              type="icon"
              variant="text"
              icon={"visibility"}
              color="black"
              size="sm"
              onClick={() => {
                setSelectedRole(row);
                setViewModal(true);
              }}
            />
          </SmartTooltip>
          <SmartTooltip description="Edit" noicon>
            <Button
              type="icon"
              variant="text"
              icon={"edit"}
              color="black"
              size="sm"
              onClick={() => {
                setEditRoleModal(true);
                setEditRoleData(row);
              }}
            />
          </SmartTooltip>
          <SmartTooltip description="User List" noicon>
            <Button
              type="icon"
              variant="text"
              icon={"groups"}
              color="black"
              size="sm"
              onClick={() => {
                setSelectedRole(row);
                setUserListModal(true);
              }}
            />
          </SmartTooltip>
          <SmartTooltip description="Delete" noicon>
            <Button
              type="icon"
              variant="text"
              icon={"delete"}
              color="black"
              size="sm"
              onClick={() => {
                setSelectedRoleId(row.id);
                setDeleteModal(true);
              }}
            />
          </SmartTooltip>
        </div>
      ),
    },
  ];
  // const rows = Array.from({ length: 10 }, (_, index) => ({
  //   id: index + 1,
  //   moduleName: moduleList[Math.floor(Math.random() * moduleList.length)],
  //   roleName: roleList[Math.floor(Math.random() * roleList.length)],
  // }));
  const roleTypeMap = {
    1: "Admin",
    2: "Research Analyst",
    3: "Business Development Manager",
    4: "Recruiter",
    5: "Employee",
    6: "Human Resources",
    7: "Finance",
    8: "Immigration",
    9: "Bench Recruiter",
    30: "Other",
  };
  const moduleMap = {
    1: "ALL", // you can rename this later if needed
    2: "ATS",
    3: "Workforce",
    4: "Benchsales",
  };
  const rows = roles.map((r) => ({
    id: r?.uiid,
    doc_id: r?._id,
    moduleName: moduleMap[r?.module] || "",
    roleName: r?.name || "",
    // roleType: roleTypeMap[r.roleType] || r.roleType,
    roleType: roleTypeMap[r?.type] || r?.type,
  }));

  const mappedRows = mapTableRows(rows, columns);
  const moduleAccessMenus = [
   !isBenchUser && {
      title: "ATS",
      page: <Ats />,
      type: "main",
    },
   !isBenchUser && {
      title: "Workforce",
      page: <Workforce />,
      type: "main",
    },
    {
      title: "Benchsales",
      page: <Benchsales />,
      type: "main",
    },
  ];
  const fetchIpRestrictions = async () => {
    try {
      setIpLoading(true);
      const res = await getAllIpRestrictionsApi({
        coll: "IpWhitelist",
        fil: JSON.stringify({ status: {type: "NONE", value: 1} }),
        lim: 25,
        pg: 1,
      });
      const data = res?.data?.data || res?.data || [];
      setIpList(data);
    } catch (error) {
      showToast("Failed to load IP whitelist", "error", 2000);
    } finally {
      setIpLoading(false);
    }
  };

  const handleIpFormChange = (field, value) => {
    setIpForm((prev) => ({ ...prev, [field]: value }));
    if (field === "ip") {
      setIpError("");
    }
  };

  const handleIpEditFormChange = (field, value) => {
    setIpEditForm((prev) => ({ ...prev, [field]: value }));
    if (field === "ip") {
      setIpEditError("");
    }
  };

  const resetIpForm = () => {
    setIpForm({
      ip: "",
      // role: "",
      description:"",
      // user: "",
      ipExpiryDate: null,
    });
    setEditingIp(null);
    setIpError("");
  };

  const handleAddIp = async () => {
    console.log("date",dateFormator(ipForm.ipExpiryDate, 'year-month-date'))
  const error = validateField({
    type: "ip",
    value: ipForm.ip,
    required: true,
    fieldName: "IP Address",
  });

  if (error) {
    setIpError(error);
    showToast(error, "error", 2000);
    return;
  }

  const ipExpiryDate = ipForm.ipExpiryDate
    ? dateFormator(ipForm.ipExpiryDate, 'year-month-date') // or keep raw if backend expects Date
    : null;

  try {
    setIpLoading(true);
    const res = await addIpRestrictionApi({
      coll: "IpWhitelist",
      payload: {
        organizationId: 1,
        ipAddress: ipForm.ip,
          // role: ipForm.role,
        description: ipForm.description,
        status: 1,
        ipExpiryDate: ipExpiryDate,
          // addedBy: ipForm.user,
      },
    });
    if (res?.data) {
      showToast("IP whitelist added", "success", 2000);
      await fetchIpRestrictions();
      resetIpForm();
    } else {
      showToast("Failed to add IP whitelist", "error", 2000);
    }

  } catch (error) {
    showToast("Something went wrong", "error", 2000);
  } finally {
    setIpLoading(false);
  }
};

  const handleUpdateIp = async () => {
    console.log("update date",dateFormator(ipEditForm.ipExpiryDate, 'year-month-date'))
  if (!editingIp?.uiid) {
    showToast("Id not found", "error", 2000);
    return false;
  }

  const error = validateField({
    type: "ip",
    value: ipEditForm.ip,
    required: true,
    fieldName: "IP Address",
  });

  if (error) {
    setIpEditError(error);
    showToast(error, "error", 2000);
    return false;
  }

  const ipExpiryDate = ipEditForm.ipExpiryDate
    ? dateFormator(ipEditForm.ipExpiryDate, 'year-month-date') // or keep raw if backend expects Date
    : null;

  try {
    setIpLoading(true);

    const res = await updateIpRestrictionApi({
      coll: "IpWhitelist",
      uiid: editingIp.uiid,
      payload: {
        $set: {
          ipAddress: ipEditForm.ip,
          status: 1,
            // role: ipEditForm.role,
          description: ipEditForm.description,
            // addedBy: ipEditForm.user,
          ipExpiryDate: ipExpiryDate,
          organizationId: 1,
        },
      },
    });

    if (res?.data) {
      showToast("IP whitelist updated", "success", 2000);
      await fetchIpRestrictions();
      setIpEditForm({ ip: "", description: "", ipExpiryDate: "" });
      return true;
    } else {
      showToast("Failed to update IP whitelist", "error", 2000);
      return false;
    }

  } catch (error) {
    showToast("Something went wrong", "error", 2000);
    return false;
  } finally {
    setIpLoading(false);
  }
};

  const handleEditIp = (row) => {
    setEditingIp(row);
    setIpEditForm({
      ip: row.ipAddress || row.startIp || row.endIp || row.ip || "",
      // role: row.role || "",
      description: row.description || "",
      // user: row.addedBy || "",
      ipExpiryDate: dateFormator(row.ipExpiryDate, 'short')|| ""
    });
    setIpEditModal(true);
    setIpEditError("");
  };

  const handleDeleteIp = (row) => {
    if (!row?.uiid && !row?.id) {
      showToast("Id not found!", "error", 2000);
      return;
    }
    setDeletingIp(row);
    setIpDeleteModal(true);
  };

  const confirmDeleteIp = async () => {
  if (!deletingIp?.uiid && !deletingIp?.id) {
    showToast("Id not found!", "error", 2000);
    return;
  }
  try {
    setIpLoading(true);

    const res = await updateIpRestrictionApi({
      coll: "IpWhitelist",
      uiid: deletingIp.uiid || deletingIp.id,
      payload: {
        $set: {
          status: 2,
        },
      },
    });

    if (res?.data) {
      showToast("IP whitelist deleted", "success", 2000);
      await fetchIpRestrictions();
      setIpDeleteModal(false);
      setDeletingIp(null);
    } else {
      showToast("Failed to delete IP restriction", "error", 2000);
    }

  } catch (error) {
    showToast("Something went wrong", "error", 2000);
  } finally {
    setIpLoading(false);
  }
};
  const handleRoleDelete = async (uiid) => {
    if (!uiid) {
      showToast("Id not found!", "error", 2000);
      return;
    }
    try {
      const res = await deleteRole({
        coll: "Role",
        uiid: uiid,
      });
      if (res?.data) {
        showToast("Role deleted", "success", 2000);
        dispatch(
          getRolesStart({
            coll: "Role",
            
            // ret: "uiid roleName module roleType",
            ret: "uiid name module type",
          })
        );
        setDeleteModal(false);
        setSelectedRoleId(null);
      }
    } catch (error) {
      showToast("Error while deleting role", "error", 2000);
    }
  };
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "roles",
        coll: "Role",
        tname: "allRoles",
        app: "master",
      })
    );
    dispatch(
      getRolesStart({
        coll: "Role",
    ...(isBenchUser && {
      fil: {
        module: { type: "NONE", value: 4 },
      },
    }),
        // ret: "uiid roleName module roleType",
        ret: "uiid name module type",
        pg: page,
        lim: limit,
      })
    );
  }, [dispatch, page, limit]);

  useEffect(() => {
    if (!isBenchUser) {
      fetchIpRestrictions();
    }
  }, [isBenchUser]);

  const tabList = [
    {
      title: "Role",
      id: "settings_accesscontrol_security_role",
      page: (
        <div className="flex flex-col flex-1 p-2 overflow-hidden h-full">
          <div className="flex-1 overflow-auto">
            <TableAdv
              rows={mappedRows}
              columns={columns}
              // serverPagination={true}
              totalCount={totalCount}
              page={page}
              limit={limit}
              onPaginationChange={setPage}
              onLimitChange={handleLimitChange}
              toolbarRight={{
                search: true,
                add: [
                  {
                    component: (
                      <Button
                        title={"Add New"}
                        icon={"add"}
                        size="sm"
                        onClick={() => setAddRoleModal(true)}
                      />
                    ),
                  },
                ],
              }}
            />
          </div>
        </div>
      ),
    },
    {
      title: "Module Access",
      id: "settings_accesscontrol_security_moduleaccess",
      page: (
        <div className="flex flex-col flex-1 p-2 overflow-hidden h-full">
          <NewTab
            tabs={moduleAccessMenus}
            color="gray"
            variant="text"
            activeVariant="text"
          />
        </div>
      ),
    },
    {
      title: "Report Access",
      id: "settings_accesscontrol_security_reportaccess",
      page: (
       <div className="flex flex-col justify-center items-center flex-1 overflow-auto ">
      <div className="flex flex-col justify-center items-center m-10">
        <h1 className="flex font-bold text-center items-center  break-words">
          Report Access
        </h1>
        <h2 className="flex font-bold text-center items-center  break-words">
          Coming soon
        </h2>
      </div>
    </div>
      ),
    },
    {
      title: "IP Whitelist",
      id: "settings_accesscontrol_security_iprestriction",
      page: ( !isBenchUser?
        <div className="flex flex-col flex-1 p-2 overflow-hidden h-full">
          <div className="flex flex-col justify-between h-full">
            <div>
              <p className="my-3">
                Whitelist Users from specific IP addresses to access your product
              </p>
              <div className="grid grid-cols-3 my-4 gap-3">
                <FormFieldSet
                  title="IP Address"
                  placeholder="IP Address"
                  value={ipForm.ip}
                  onChange={(value) => handleIpFormChange("ip", value)}
                  error={ipError}
                />
                <FormFieldSet
                  title="Description"
                  placeholder="Description"
                  value={ipForm.description}
                  onChange={(value) => handleIpFormChange("description", value)}
                />
                <FormFieldSet
                  title="Ip Expiry Date"
                  placeholder="Select date"
                  type="datepicker"
                  value={ipForm.ipExpiryDate}
                  onChange={(value) => handleIpFormChange("ipExpiryDate", value)}
                  showDropdown={false}
                />
                {/* <FormFieldSet
                  title="Role"
                  placeholder="Role"
                  value={ipForm.role}
                  onChange={(value) => handleIpFormChange("role", value)}
                />
                <FormFieldSet
                  title="User"
                  placeholder="User"
                  value={ipForm.user}
                  onChange={(value) => handleIpFormChange("user", value)}
                /> */}
              </div>
            </div>
            <div className="flex justify-end gap-2 my-3 mx-2">
              <Button
                variant="outlined"
                title={"Cancel"}
                onClick={resetIpForm}
              />
              <Button
                title={"Save"}
                onClick={handleAddIp}
                disabled={ipLoading}
              />
            </div>
            <div className="flex-1 overflow-auto mt-4">
              <TableAdv
                rows={ipList.map((ip) => ({
                  ...ip,
                  ip: ip.ipAddress || ip.startIp || ip.endIp || ip.ip || "",
                  // user: ip.addedBy,
                  ipExpiryDate: dateFormator(ip.ipExpiryDate, 'short') || "",
                  actions: (
                    <div className="flex items-center gap-2">
                      <SmartTooltip description="Edit" noicon>
                        <Button
                          type="icon"
                          variant="text"
                          icon={"edit"}
                          color="black"
                          size="sm"
                          onClick={() => handleEditIp(ip)}
                        />
                      </SmartTooltip>
                      <SmartTooltip description="Delete" noicon>
                        <Button
                          type="icon"
                          variant="text"
                          icon={"delete"}
                          color="black"
                          size="sm"
                          onClick={() => handleDeleteIp(ip)}
                        />
                      </SmartTooltip>
                    </div>
                  ),
                }))}
                columns={[
                  { key: "ip", label: "IP Address" },
                  { key: "description", label: "Description" },
                  // { key: "role", label: "Role" },
                  // { key: "user", label: "User" },
                  { key: "ipExpiryDate", label: "Expiry Date" },
                  { key: "actions", label: "Actions" },
                ]}
                loading={ipLoading}
              />
            </div>
          </div>
        </div>
        :
        <div className="flex flex-col justify-center items-center flex-1 overflow-auto ">
      <div className="flex flex-col justify-center items-center m-10">
        <h1 className="flex font-bold text-center items-center  break-words">
          IP Whitelist
        </h1>
        <h2 className="flex font-bold text-center items-center  break-words">
          Coming soon
        </h2>
      </div>
    </div>
      ),
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: tabList,
    parentId: "settings_accesscontrol_security",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });
  return (
    <div className="flex flex-1 pt-2 overflow-hidden">
      {/* <div className="grid grid-cols-[2fr_10fr] m-4 gap-10 w-full">
        <div className="shadow">
          {options.map((option, index) => (
            <div
              key={index}
              className={`py-3 px-2 border-b border-[#e7e7e7] cursor-pointer ${
                activeIndex === index ? "bg-primary-100" : "bg-white"
              }`}
              onClick={() => setActiveIndex(index)}
            >
              {option}
            </div>
          ))}
        </div>
        <div className="border border-[#e7e7e7] rounded-lg p-2 ">
          {activeIndex === 0 ? (
            <NewTableAdv
              rows={mappedRows}
              columns={columns}
              serverPagination={true}
              totalCount={totalCount}
              page={page}
              limit={limit}
              onPageChange={setPage}
              onLimitChange={handleLimitChange}
              toolbarRight={{
                search: true,
                add: [
                  {
                    component: (
                      <Button
                        title={"Add New"}
                        icon={"add"}
                        size="sm"
                        onClick={() => setAddRoleModal(true)}
                      />
                    ),
                  },
                ],
              }}
            />
          ) : activeIndex === 1 ? (
            <div>
             
            </div>
          ) : activeIndex === 2 ? (
            <div>Report Access</div>
          ) : (
            <div className="flex flex-col justify-between h-full">
              <div>
                <p className="my-3">
                  Restrict Users from specific IP addresses to access your
                  product
                </p>
                <Button variant="outlined" title={"Add New IP"} />
                <div className="grid grid-cols-3 my-4 gap-3">
                  <FormFieldSet title="Start IP" placeholder="Start IP" />
                  <FormFieldSet title="End IP" placeholder="Start IP" />
                  <FormFieldSet
                    title="Role"
                    placeholder="Select"
                    type="select"
                  />
                  <FormFieldSet
                    title="User"
                    placeholder="Select"
                    type="select"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-2 my-3 mx-2">
                <Button variant="outlined" title={"Cancel"} />
                <Button title={"Save"} />
              </div>
            </div>
          )}
        </div>
      </div> */}
      <VerticalTabs tabs={filteredTabs} />
      <Modal
        title={"Add Role"}
        isOpen={addRoleModal}
        onClose={() => setAddRoleModal(false)}
        width="max-w-xl"
        titleColor={"primary"}
      >
        <AddRole onCancel={() => setAddRoleModal(false)} isBenchUser={isBenchUser} />
      </Modal>

      <Modal
        title={"Edit IP Whitelist"}
        isOpen={ipEditModal}
        onClose={() => {
          setIpEditModal(false);
          setEditingIp(null);
        }}
        width="max-w-xl"
        titleColor={"primary"}
      >
        <div className="flex flex-col gap-4 p-2">
          <FormFieldSet
            title="IP Address"
            placeholder="IP Address"
            value={ipEditForm.ip}
            onChange={(value) => handleIpEditFormChange("ip", value)}
            error={ipEditError}
          />
          <FormFieldSet
            title="Description"
            placeholder="Description"
            value={ipEditForm.description}
            onChange={(value) => handleIpEditFormChange("description", value)}
          />
          <FormFieldSet
            title="Ip Expiry Date"
            placeholder="Select date"
            type="datepicker"
            value={ipEditForm.ipExpiryDate}
            onChange={(value) => handleIpEditFormChange("ipExpiryDate", value)}
            showDropdown={false}
          />
          {/* <FormFieldSet
            title="Role"
            placeholder="Role"
            value={ipEditForm.role}
            onChange={(value) => handleIpEditFormChange("role", value)}
          />
          <FormFieldSet
            title="User (Added By)"
            placeholder="User"
            value={ipEditForm.user}
            onChange={(value) => handleIpEditFormChange("user", value)}
          /> */}
          <div className="flex justify-end gap-2 mt-4">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => {
                setIpEditModal(false);
                setEditingIp(null);
              }}
            />
            <Button
              title={"Update"}
              onClick={async () => {
                const success = await handleUpdateIp();
                if (success) {
                  setIpEditModal(false);
                  setEditingIp(null);
                }
              }}
              disabled={ipLoading}
            />
          </div>
        </div>
      </Modal>

      <Modal
        title={"View Role"}
        isOpen={viewModal}
        onClose={() => setViewModal(false)}
        width="max-w-xl"
        titleColor={"primary"}
      >
        <ViewRole role={selectedRole} />
      </Modal>

      <Modal
        title={"Edit Role"}
        isOpen={editRoleModal}
        onClose={() => setEditRoleModal(false)}
        width="max-w-xl"
        titleColor={"primary"}
      >
        <AddRole onCancel={() => setEditRoleModal(false)} data={editRoleData} />
      </Modal>

      <Modal
        title={"User List"}
        isOpen={userListModal}
        onClose={() => setUserListModal(false)}
        width="max-w-4xl"
        titleColor={"primary"}
      >
        <UserList
          selectedRole={selectedRole}
          onClose={() => setUserListModal(false)}
        />
      </Modal>

      <Modal
        showCloseButton={false}
        isOpen={deleteModal}
        onClose={() => setDeleteModal(false)}
        width="max-w-xl"
        closeOnOutsideClick
      >
        <div className="flex flex-col items-center p-4 py-10">
          <p>Are you sure you want to delete this role permanently ?</p>
          <div className="flex gap-4 mt-5">
            <Button
              title={"Cancel"}
              variant="outlined"
              color="black"
              onClick={() => setDeleteModal(false)}
            />
            <Button
              title={"Delete"}
              // onClick={() => setDeleteModal(false)}
              onClick={() => handleRoleDelete(selectedRoleId)}
            />
          </div>
        </div>
      </Modal>

      <Modal
        showCloseButton={false}
        isOpen={ipDeleteModal}
        onClose={() => setIpDeleteModal(false)}
        width="max-w-xl"
        closeOnOutsideClick
      >
        <div className="flex flex-col items-center p-4 py-10">
          <p>Are you sure you want to delete this IP restriction permanently ?</p>
          <div className="flex gap-4 mt-5">
            <Button
              title={"Cancel"}
              variant="outlined"
              color="black"
              onClick={() => {
                setIpDeleteModal(false);
                setDeletingIp(null);
              }}
            />
            <Button
              title={"Delete"}
              onClick={confirmDeleteIp}
              disabled={ipLoading}
            />
          </div>
        </div>
      </Modal>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Security;